export default __webpack_public_path__ + "static/media/giv_brand.5ae43ecb.svg";